import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * NotFound — RTE-02. Catch-all 404 route.
 *
 * Renders inside the same RootLayout as every other route, so Nav + Footer
 * remain visible (RTE-02 / Phase 2 success criterion #3).
 *
 * Does NOT set HTTP status code 404 — this is an SPA, every route returns 200
 * at the HTTP layer. Phase 5 SEO-01..06 will configure the host to serve 200
 * for the SPA fallback (Phase 7 HOST-01..05 ships the per-host configs).
 */
export function NotFound(): JSX.Element {
  const { t } = useTranslation();
  return (
    <main className="bg-paper text-ink min-h-[60vh]">
      <div className="mx-auto max-w-3xl px-6 py-16">
        <h1 className="text-h1 font-sans">{t('notFound.title')}</h1>
        <p className="text-body text-dim mt-6">{t('notFound.body')}</p>
      </div>
    </main>
  );
}

export default NotFound;
